import React from 'react'

type Props = {
  rating: number
  iconClassName?: string
  wrapperClassName?: string
}

const ReviewStars = ({rating, iconClassName = 'fs-6', wrapperClassName = ''}: Props) => (
  <div className={wrapperClassName}>
    {Array.from({length: 5}, (_, index) => (
      <i
        key={index}
        className={`bi bi-star-fill ${iconClassName}`}
        style={{color: index < rating ? '#f7b718' : '#d6d6d6'}}
      />
    ))}
  </div>
)

export {ReviewStars}
